const Header = () => {
    return(
        <header>
            <div id="branding">
                <div className="logo"><img src={process.env.PUBLIC_URL + "/noaa-emblem-wt-rgb-2022.svg"} alt="NOAA Logo"/></div>
                <div className="text">
                    <h1>PAR Images</h1>
                    <h2>Phased Array Radar Image Application</h2>
                </div>
            </div>
        </header>
    );
}

export default Header;